import type { ReactNode } from 'react'
import { MotionIllust } from '@/components/parts/motion-illust'

type RailCardProps = {
  /**
   * 見出し。改行位置は `<wbr />` で指定する（見出しは語の途中で折り返さない）
   */
  title: ReactNode
  /** 見出しの下に置く補足文 */
  lead?: string
  /**
   * 見出しの上に置くイラスト。白い円（200×200）いっぱいに置く。
   * 円の中での位置（Figma の left 26 / top 21）は SVG 側の viewBox に含めて書き出してある。
   * Figma: rail Type=notice の logo
   */
  illustSrc?: string
  illustAlt?: string
  /** ページ内リンクの着地点（本文の「お申し込みはこちら」ボタンから飛ぶ） */
  id?: string
  children?: ReactNode
}

/**
 * 詳細ページ右カラムのカード。Figma: rail（Type=form / Type=notice）の card。
 * 生成りの面に 24px の見出しを中央寄せで置き、下にフォームなどを並べる。
 * イラスト付き（notice）は中身を中央に寄せ、間隔を 24 に詰める。
 */
export function RailCard({
  title,
  lead,
  illustSrc,
  illustAlt = '',
  id,
  children
}: RailCardProps) {
  return (
    <section
      id={id}
      className={`flex flex-col rounded-xl bg-surface-subtle p-6 lg:p-8 ${
        illustSrc ? 'items-center gap-6' : 'gap-8'
      }`}
    >
      {illustSrc ? (
        <div className="size-50 shrink-0 overflow-hidden rounded-full bg-surface">
          <MotionIllust
            src={illustSrc}
            alt={illustAlt}
            width={200}
            height={200}
            className="size-50"
            loading="lazy"
          />
        </div>
      ) : null}
      <div className="flex w-full flex-col gap-3">
        <h2 className="fontfeaturesettings break-keep text-center text-2xl font-bold tracking-heading text-ink">
          {title}
        </h2>
        {lead ? (
          <p className="text-center text-sm leading-compact text-ink">{lead}</p>
        ) : null}
      </div>
      {children}
    </section>
  )
}
